$(document).ready(function(){
  
 
  $('body').on("click",".custom_tag",function(e){
    e.preventDefault();
    window.location= $(this).attr("href");
  });
  $('body').on("click","button[data-action='reset-tags']",function(e){
    e.preventDefault();
    var url = $(this).attr("data-url");
    window.location= url;
  });
  if($(window).width() <= 769){
    $('body').on('click',".Collapsible__Button",function(e){
      var hide= $(this).attr("aria-expanded");
      $('.Collapsible__Button').attr("aria-expanded","false");
      if(hide == 'false'){
        $(this).attr("aria-expanded","true");
      }

    });
  }
  
  
//   var enble = $('body').data('enble_shipping');
//   //shipping protection js


//   function get_shipping_init(){
//     console.log("sssssss");
//     $.getJSON('/cart.js', function(c){
//       var hasitem = false;
//       var cvp;
//       var rid;
//       if(c.item_count > 0){
//         $.each(c.items,function(i,cv){
//           var al_handle = cv.product_id;          
//           var number = parseInt('4490964631606');
//           if(al_handle == number){
//             if(c.item_count == 1){
//               location.href="/cart/clear";
//             }else{  
//               hasitem = true;
//               rid = cv.id;
//               cvp = cv.price;
//             }
//           }
//         });

//         if(hasitem == false){           
//           if( enble ){
//             $('.cart_form').find('.shippping_check').attr('checked','checked');
//             var price = $('.cart_form').find('.st-price').attr('data-without-currency').replace(',',''); 
//             condition(price); 
//           }                    
//         }else{
//           $('.loader').addClass('active');
//           var newp = $('.cart_form').find('.st-price').attr('data-without-currency'); 
//           var did;
//           var varid;
//           if( 0 < newp && 101 > newp ){
//             varid = 1;
//           }
//           else if( 101 < newp && 201 > newp ){
//             varid = 2;
//           }
//           else if( 201 < newp && 301 > newp ){
//             varid = 3;
//           }        
//           else if( 301 < newp && 401 > newp ){
//             varid = 4;
//           }
//           else if( 401 < newp && 501 > newp ){
//             varid = 5;
//           }
//           else if( 501 < newp && 601 > newp ){
//             varid = 6;
//           }
//           else if( 601 < newp && 701 > newp ){
//             varid = 7;
//           }
//           else if( 701 < newp && 801 > newp ){
//             varid = 8;
//           }
//           else if( 800 < newp && 901 > newp ){
//             varid = 9;
//           }
//           else if( 901 < newp && 1001 > newp ){
//             varid = 10;
//           }
//           else if( 1001 < newp && 1501 > newp ){          
//             varid = 11;
//           }
//           else if( 1501 < newp && 2500 > newp ){
//             varid = 12;
//           }
//           else if( 2500 < newp ){
//             varid = 13;
//           }
//           $.ajax({
//             type: "POST",
//             url: '/cart/update.js',
//             async: false,
//             data: 'updates['+rid+']=0',
//             success: function(){
//               document.dispatchEvent(new CustomEvent('cart:build'));
//             },
//             dataType: 'json'
//           });
//           setTimeout(function(){
//             var price = $('.cart_form').find('.st-price').attr('data-without-currency').replace(',',''); 
//             condition(price); 
//           }, 1000);
//         }
//       }
//     });
//   }
  
//   var location = window.location.href;
//   if(location.indexOf("/cart") >= 0){        
//     get_shipping_init();
//   }
  

    $('body').on('click','.shippping_check',function(){
      if($(this).attr('checked') == undefined){
        $('.shippping_check').attr('checked','checked');  
        setCookie("already_checked",1); 
      }else{ 
        $('.shippping_check').removeAttr('checked');
        setCookie("already_checked",0);
      }
      set_protection_plan_product();
    });
  
  function add_note(){
    if($('#AppFrameMain form .search__btn').length){
      $('#AppFrameMain form .search__btn').after('<h5 class="return_note"><strong>Note:</strong> Please note damages must be reported with image evidence within 24hrs of delivery for a successful claim.</h5>');
    }else{
      setTimeout(function(){
        add_note();
      },1000);
    }
  }
  if(window.location.href.indexOf('/apps/return_prime') > -1){
    add_note();
  }

    if((getCookie("already_checked") == '') && $('#shippping_calculatemini_cart').length > 0){
    $('#shippping_calculatemini_cart').attr('checked','checked');
    setCookie("already_checked",1); 
  }
  if(getCookie("already_checked") == 1){
    $('.shippping_check').attr('checked','checked');
  }



  $('body').on('click','.shipping_remove',function(){ 
      setCookie("already_checked",0); 
      set_protection_plan_product();
    });

  $(window).scroll(function(){
    if($('body').hasClass('template-collection') && $('.site-header').hasClass('site-header--opening')){
      var header_height = $('.header-sticky-wrapper').height();
      $('.template-collection .grid__item--sidebar').css('top' , header_height);
    }    
  });    
  
  
});

